import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import './Teen1.css';
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Teen1() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "teen1";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
       gameName={"1 CARD ONE-DAY"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container onecard1day"> */}
      {/* <div className="casino-header">
          <span className="casino-name">
            1 CARD ONE-DAY
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>145250430220130</span>
            </small>
          </span>
        </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>145250430220130</span>
            </span>
          </div>
        </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video">
            <div className="video-box-container">
              <div className="casino-video-box">
              </div>
            </div>
            <div className="casino-video-cards">
              <div>
                <div>
                  <h5>Player</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/JHH.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/JHH.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <h5>Dealer</h5>
                  <div className="flip-card-container mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">5</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">5</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}

      <div className="casino-detail onecard1day">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail onecard1day">
                    <div className="casino-nation-name">
                      Player
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(casinoPlData, "Player")}
                      </p>
                    </div>
                    <div className="casino-nation-book text-success" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  onecard1day ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay onecard1day  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Player", casinoData, false)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Dealer
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(casinoPlData, "Dealer")}
                      </p>
                    </div>
                    <div className="casino-nation-book text-success" />
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div
                    className={`casino-odds-box back onecard1day ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dealer", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Dealer", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div
                    className={`casino-odds-box lay onecard1day  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dealer", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Dealer", casinoData, false)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3 sevenupbox">
            <div className="casino-table-left-box">
              <h4 className="d-md-none mb-2">Player</h4>
              <div className="seven-up-down-box onecard1day">
                {/* <div className="up-box suspended-box"> */}
                <div
                  className={`casino-odds-box back onecard1day ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("7 Down Player", casinoData, dispatch, "back")
                  }
                >
                  <div className="up-down-book onecard1day" />
                  <div className="text-end">
                    <div className="up-down-odds onecard1day">
                      {" "}
                      {getOddForEntity("7 Down Player", casinoData, true)}
                    </div>
                    <span>
                      DOWN
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "7 Down Player"
                        )}
                      </p>
                    </span>
                  </div>
                </div>
                {/* <div className="down-box suspended-box"> */}
                <div
                  className={`casino-odds-box back onecard1day  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("7 Up Player", casinoData, dispatch, "back")
                  }
                >
                  <div className="up-down-book onecard1day" />
                  <div className="text-start">
                    <div className="up-down-odds onecard1day">
                      {" "}
                      {getOddForEntity("7 Up Player", casinoData, true)}
                    </div>
                    <span>
                      UP
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "7 Up Player"
                        )}
                      </p>
                    </span>
                  </div>
                </div>
                <div className="seven-box onecard1day">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/trape-seven.png" />
                </div>
              </div>
            </div>
              <div className="casino-table-left-box">
              <h4 className="d-md-none mb-2">Dealer</h4>
              <div className="seven-up-down-box onecard1day">
                {/* <div className="up-box suspended-box"> */}
                <div
                  className={`casino-odds-box back onecard1day ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("7 Down Dealer", casinoData, dispatch, "back")
                  }
                >
                  <div className="up-down-book onecard1day" />
                  <div className="text-end">
                    <div className="up-down-odds onecard1day">
                      {" "}
                       {getOddForEntity("7 Down Dealer", casinoData, true)}
                      {/* {getOddForEntity("7 Down Player", casinoData, true)} */}
                    </div>
                    <span>
                      DOWN
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                            "7 Down Dealer"
                        )}
                      </p>
                    </span>
                  </div>
                </div>
                {/* <div className="down-box suspended-box"> */}
                <div
                  className={`casino-odds-box back onecard1day ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                 onClick={() =>
                    setBet("7 Up Dealer", casinoData, dispatch, "back")
                  }
                >
                  <div className="up-down-book onecard1day" />
                  <div className="text-start">
                    <div className="up-down-odds onecard1day">
                      {" "}
                         {getOddForEntity("7 Up Dealer", casinoData, true)}
                      {/* {getOddForEntity("7 Up Player", casinoData, true)} */}
                    </div>
                    <span>
                      UP
                      <p className="casino-nation-book ">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                           "7 Up Dealer"
                        )}
                      </p>
                    </span>
                  </div>
                </div>
                <div className="seven-box onecard1day">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/trape-seven.png" />
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            {/* <div className="casino-table-right-box">
              <h4 className="d-md-none mb-2">Dealer</h4>
              <div className="seven-up-down-box">
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("7 Down Dealer", casinoData, dispatch, "back")
                  }
                >
                  <div className="up-box">
                    <div className="up-down-book" />
                    <div className="text-end">
                      <div className="up-down-odds">
                        {" "}
                        {getOddForEntity("7 Down Dealer", casinoData, true)}
                      </div>
                      <span>
                        DOWN
                        <p className="casino-nation-book ">
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "7 Down Dealer"
                          )}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("7 Up Dealer", casinoData, dispatch, "back")
                  }
                >
                  <div className="down-box">
                    <div className="up-down-book" />
                    <div className="text-start">
                      <div className="up-down-odds">
                        {" "}
                        {getOddForEntity("7 Up Dealer", casinoData, true)}
                      </div>
                      <span>
                        UP
                        <p className="casino-nation-book ">
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "7 Up Dealer"
                          )}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="seven-box">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/trape-seven.png" />
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/teen1">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">D</span>
              <span className="result result-a">P</span>
              <span className="result result-b">D</span>
              <span className="result result-b">D</span>
              <span className="result result-b">D</span>
              <span className="result result-a">P</span>
              <span className="result result-b">D</span>
              <span className="result result-b">D</span>
              <span className="result result-b">D</span>
              <span className="result result-b">D</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box place-bet-container">
        <div className="sidebar-title">
          <h4>Place Bet</h4>
          <span>Range: 100.00 to 5L</span>
        </div>
        <div className="place-bet-box back">
          <div className="place-bet-box-header">
            <div className="place-bet-for">(Bet for)</div>
            <div className="place-bet-odds">Odds</div>
            <div className="place-bet-stake">Stake</div>
            <div className="place-bet-profit">Profit</div>
          </div>
          <div className="place-bet-box-body">
            <div className="place-bet-for">
              <i className="fas fa-times text-danger me-1" />
              <span>Dealer</span>
            </div>
            <div className="place-bet-odds">
              <input
                type="text"
                className="form-control"
                disabled=""
                defaultValue="1.98"
              />
            </div>
            <div className="place-bet-stake">
              <input type="number" className="form-control" defaultValue="" />
            </div>
            <div className="place-bet-profit" />
          </div>
          <div className="place-bet-buttons">
            <button className="btn btn-place-bet">+25</button>
            <button className="btn btn-place-bet">+50</button>
            <button className="btn btn-place-bet">+100</button>
            <button className="btn btn-place-bet">+200</button>
            <button className="btn btn-place-bet">+500</button>
            <button className="btn btn-place-bet">+1000</button>
            <button className="btn btn-sm btn-link text-dark flex-fill text-end">
              clear
            </button>
          </div>
          <div className="place-bet-action-buttons">
            <div>
              <button className="btn btn-info">Edit</button>
            </div>
            <div>
              <button className="btn btn-danger me-1">Reset</button>
              <button className="btn btn-success" disabled="">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
